import { useExperiment } from '@statsig/react-bindings';

const usePDPExperiment = () => {
  return useExperiment('or4_pdp').get('showPDP', false);
};

export default usePDPExperiment;
